import { Label as LabelView } from './Label.view';
export * from './Label.view';

export const Label = (props) => LabelView(props);

export default Label;

